import { SearchByItem } from "@app/shared/classes/general";
import { TableColumnDef } from "@app/shared/components/smart-data-grid/data-grid/data-grid.constants";

export enum ReportLinkFieldName {
  reportName = "reportName",
  reportUrl = "reportUrl",
  description = "description"
};

enum FieldLabel {
  REPORT_NAME = "ml_144101",
  LINK = "ml_144102",
  DESCRIPTION = "ml_143964"
}

export const DataGridColumnDef: TableColumnDef[] = [
  {
    text: FieldLabel.REPORT_NAME,
    name: ReportLinkFieldName.reportName,
    sort: true
  },
  {
    text: FieldLabel.LINK,
    name: ReportLinkFieldName.reportUrl,
    sort: false
  },
  {
    text: FieldLabel.DESCRIPTION,
    name: ReportLinkFieldName.description,
    sort: false
  },
]

const ExternalReportSearchByList: SearchByItem[] = [
  { searchBy: ReportLinkFieldName.reportName, searchByLabel: FieldLabel.REPORT_NAME },
];

export const GeExternalReportSearchByList = () => {
  return ExternalReportSearchByList.slice();
}
